import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const HOUR_TIMESPAN_IN_MS = 1000 * 60 * 60;

// Returns true if the user's mailbox has been created within the last hour
export default function isNewUser() {
    // Use the feature to test the non-New user situation which is safer than the query string which could be leaked to the production
    if (isFeatureEnabled('fwk-ads-exp2-ByPassNewUserCheck')) {
        return true;
    }

    let createDate = new Date(getUserConfiguration().MailboxCreateDate);

    return Date.now() - createDate.getTime() < HOUR_TIMESPAN_IN_MS;
}
